import template from "./one-million-impacts-progress-bar.html";
import "./themes/one-million-impacts-progress-bar.component.scss";
import "./themes/one-million-impacts-progress-bar.component-dark.scss";
class OneMillionImpactsProgressBarComponent {
    positionMark = 0;
    classColorMark = "";
    progressLineColors = {
        bronze: {
            start: 0,
            end: 10,
            impactsEnd: 10,
            class: "bronze"
        },
        silver: {
            start: 21,
            end: 38,
            impactsEnd: 100,
            class: "silver"
        },
        gold: {
            start: 51,
            end: 77,
            impactsEnd: 1000,
            class: "gold"
        },
        ambassador: {
            impactsEnd: 1300,
            start: 91,
            end: 99,
            class: "ambassador"
        }
    };
    constructor() {}

    $onInit() {
        this._setProgress();
    }

    _setProgress() {
        let dataLineColor = {};
        if (this.impacts <= 10) {
            dataLineColor = this.progressLineColors.bronze;
        } else if (this.impacts >= 11 && this.impacts <= 100) {
            dataLineColor = this.progressLineColors.silver;
        } else if (this.impacts >= 101 && this.impacts <= 1000) {
            dataLineColor = this.progressLineColors.gold;
        } else {
            dataLineColor = this.progressLineColors.ambassador;
        }

        this.classColorMark = dataLineColor.class;

        if (this.impacts >= 1300) {
            this.positionMark = this.progressLineColors.ambassador.end;
            return;
        }
        this.positionMark = dataLineColor.start;
        const impactsBar = [...new Array(dataLineColor.end + 1)].map(
            (v, k) => k
        );
        const percentImpact = ~~(
            (this.impacts / dataLineColor.impactsEnd) *
            100
        );
        const impactsBarArray = impactsBar.slice(
            dataLineColor.start,
            impactsBar.length
        );
        this.positionMark =
            impactsBarArray[~~((percentImpact * impactsBarArray.length) / 100)];
    }
}

OneMillionImpactsProgressBarComponent.$inject = [];

const component = {
    controller: OneMillionImpactsProgressBarComponent,
    bindings: {
        impacts: "<"
    }
};

component.template = template;

angular
    .module("nucont.shared")
    .component("oneMillionImpactsProgressBarComponent", component);
